import React from "react";

import {
  InstrumentSelection,
  ManualPriceEntry,
} from "../../components/InstrumentEditor";
import { PendingFixItem, WorkItemDetailProps } from "../types";
import { CorporateActionDetail } from "./CorporateActionDetail";
import { InstrumentFixDetail } from "./InstrumentFixDetail";
import { ResolvedActionDetail } from "./ResolvedActionDetail";
import { ResolvedFixDetail } from "./ResolvedFixDetail";
import { ResolvedRequestDetail } from "./ResolvedRequestDetail";
import { TickerRequestDetail } from "./TickerRequestDetail";

export const WorkItemDetail: React.FC<WorkItemDetailProps> = ({
  item,
  isSubmitting,
  isFixBlocked,
  isActionBlocked,
  error,
  fixErrors,
  onApprove,
  onReject,
  onSaveCountry,
  onRepairListing,
  onUseManualPricing,
  onDeferAction,
  onResumeAction,
  onReconcileAction,
  onClearError,
}) => {
  if (item.status === "resolved") {
    if (item.kind === "corporate") {
      return <ResolvedActionDetail resolution={item.resolution} />;
    }
    return item.kind === "instrument" ? (
      <ResolvedFixDetail resolution={item.resolution} />
    ) : (
      <ResolvedRequestDetail resolution={item.resolution} />
    );
  }

  if (item.kind === "corporate") {
    const handleDefer = () => onDeferAction(item);
    const handleResume = () => onResumeAction(item);
    const handleReconcile = () => onReconcileAction(item);

    return (
      <CorporateActionDetail
        key={item.key}
        item={item}
        isSubmitting={isActionBlocked}
        error={error}
        onDefer={handleDefer}
        onResume={handleResume}
        onReconcile={handleReconcile}
      />
    );
  }

  if (item.kind === "instrument") {
    const fix: PendingFixItem = item;
    const handleSaveCountry = (sourceCountry: string | null) =>
      onSaveCountry(fix, sourceCountry);
    const handleRepairListing = (yahooSymbol: string) =>
      onRepairListing(fix, yahooSymbol);
    const handleUseManualPricing = (entry: ManualPriceEntry) =>
      onUseManualPricing(fix, entry);

    return (
      <InstrumentFixDetail
        key={fix.key}
        fix={fix}
        isSubmitting={isFixBlocked}
        errors={fixErrors}
        onSaveCountry={handleSaveCountry}
        onRepairListing={handleRepairListing}
        onUseManualPricing={handleUseManualPricing}
        onClearError={onClearError}
      />
    );
  }

  const { request } = item;
  const handleApprove = (selection: InstrumentSelection) =>
    onApprove(request, selection);
  const handleReject = (reason: string) => onReject(request, reason);

  return (
    <TickerRequestDetail
      key={item.key}
      request={request}
      isSubmitting={isSubmitting}
      error={error}
      onApprove={handleApprove}
      onReject={handleReject}
      onClearError={onClearError}
    />
  );
};
